import { createPortal } from "react-dom";

/* body 로 빼서 그린다. 채팅 본문처럼 container-type 이 걸린 상자 안에서 부르면 fixed 기준이
   그 상자가 되어 화면 가운데에 뜨지 않는다. 다이얼로그(z-50) 안에서 불러도 위에 보이게 z-[60] 을 준다 */
const Spinner = () => {
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <img
        src="/images/loading_animation.gif"
        alt="loading"
        className="w-[72px] h-[72px] opacity-90 shadow-lg rounded-full"
      />
    </div>,
    document.body
  );
};

export default Spinner;
